import map from "lodash/map"
import find from "lodash/find"
import commonApiAuthRequest from "../apiAuthRequest"
import { SAP_LOADER_SERVICE_URL, PASSPORT_REFERENCE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/toro-reference-integration/version%2F1.0/toro-sap-loader.oas2.yml?view=%2Freference%2Fget-issue-materials%2Fget-issue-materials
*/

const mtsFetch = sapIssueId =>
  commonApiAuthRequest({
    url: `${SAP_LOADER_SERVICE_URL}/get_issue_materials`,
    method: `post`,
    data: {
      where: {
        issueNumber: sapIssueId,
      },
    },
  })

const materialFetch = nomenclature =>
  commonApiAuthRequest({
    url: `${PASSPORT_REFERENCE_URL}/objects/data/rowByKey/material/v1/${nomenclature}`,
    params: {},
  })

/**
 * makes request to get planned materials by sapIssueId
 *
 * @param {number} sapIssueId
 * @return {Array.<Object>} response - array of planned materials
 */
export const getPlannedMts = async sapIssueId => {
  if (!sapIssueId) {
    return undefined
  }

  const { data: plannedMts } = await mtsFetch(sapIssueId)
  const nomenclatures = map(plannedMts, `materialNumber`)
  const mtsResponse = await Promise.all(
    map(nomenclatures, payload => materialFetch(payload)),
  )
  const mtsInfo = map(mtsResponse, `data`)

  const mtsWithNames = map(plannedMts, originalMts => ({
    ...originalMts,
    name: find(mtsInfo, [`code`, originalMts.materialNumber]).name,
  }))

  return mtsWithNames
}
